import config from 'config/config';
import { setGlobalError } from 'containers/ErrorHandler/actions';
import { api } from 'redux/api/index.api';
import globalMessages from 'translations/messages/global-messages';
import { getRegistrationServiceVersion } from 'utils/constants';

export const userApi = api.injectEndpoints({
  endpoints: builder => ({
    verifyEmail: builder.mutation({
      query: ({ email }) => ({
        url: `${getRegistrationServiceVersion()}/user/verify-email/${email}`,
        method: 'POST',
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (!data?.is_email_verified) {
            dispatch(
              setGlobalError({
                data,
                customErrorMessageIntl: globalMessages.inexisting_email,
              }),
            );
          }
        } catch (error) {
          console.error('Error verifiying email:', error);
        }
      },
    }),
    fetchUserAccessToApiKeyCreation: builder.query({
      query: () => ({
        url: `user`,
        method: 'GET',
      }),
    }),
    fetchUserAuthenticationInfo: builder.query({
      query: ({ email }) => ({
        url: `${getRegistrationServiceVersion()}/user/user-authentication-info/${email}`,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${config.apiRegistrationToken}`,
          'Cache-Control': 'No-Store',
          'Content-Type': 'application/json',
        },
      }),
    }),
    resetPassword: builder.mutation({
      query: ({ email }) => ({
        url: `${getRegistrationServiceVersion()}/user/reset-password/${email}`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${config.apiRegistrationToken}`,
        },
        body: {
          send_reset_password_email: true,
        },
      }),
    }),
  }),
  overrideExisting: 'throw',
});

export const {
  useVerifyEmailMutation,
  useFetchUserAccessToApiKeyCreationQuery,
  useLazyFetchUserAuthenticationInfoQuery,
  useResetPasswordMutation,
} = userApi;
